// La flashcard : un vrai carton à deux faces, et le seul geste de l'onglet.
//
// C'est un <button> : Espace et Entrée le retournent, le doigt le tape, le lecteur d'écran l'annonce comme un
// bouton à deux états (aria-pressed). Les deux faces sont dans le DOM et le carton pivote réellement
// (perspective, rotateY, backface-visibility, 320 ms) : on voit que c'est LE MÊME carton qu'on vient de
// retourner, ce qui est tout le sens du geste. Un simple changement de contenu ne dit pas cela.
//
// Le retournement ne redessine rien : window.actions.flashFlip ne touche qu'aria-pressed et l'attribut hidden
// des deux rangées d'action — sinon l'animation serait coupée net par un nouveau rendu.
import { html, attr } from '../../core/html.js';
import { ico } from '../icones.js';
import { puceRang } from './qcm-jauge.js';

function jours(n) { return n + ' j'; }

// Les quatre notes de la répétition espacée, avec l'échéance que chacune donne — la conséquence se lit avant
// de choisir. Les intervalles sont ceux de window.actions.flashRate (src/legacy/qcm.js).
export function notesCarte(card) {
    var ivl = card.ivl || 0;
    var NOTES = [
        ['again', 'Oublié', 'revient dans 10 min', 'qcm-note-again'],
        ['hard', 'Difficile', '+ ' + jours(Math.max(1, Math.round(ivl * 1.2))), 'qcm-note-hard'],
        ['good', 'Acquis', '+ ' + jours(ivl < 1 ? 1 : Math.round(ivl * 2.5)), 'qcm-note-good'],
        ['easy', 'Facile', '+ ' + jours(ivl < 1 ? 3 : Math.round(ivl * 4)), 'qcm-note-easy']
    ];
    return html`${NOTES.map(function(n) {
        return html`<button type="button" class="qcm-note ${n[3]}" data-action="flashRate" data-args="${attr([n[0]])}">
            <span class="qcm-note-mot">${n[1]}</span><span class="qcm-note-quand num">${n[2]}</span>
        </button>`;
    })}`;
}

export function carteFlash(card, f) {
    var retournee = !!f.flipped;
    return html`<div class="qcm-flip">
        <button type="button" class="qcm-flip-btn" data-action="flashFlip" aria-pressed="${retournee ? 'true' : 'false'}">
            <span class="qcm-flip-carton">
                <span class="qcm-face qcm-face-recto"${retournee ? html` aria-hidden="true"` : ''}>
                    <span class="qcm-face-role">Question</span>
                    <span class="qcm-face-texte">${card.recto}</span>
                    <span class="qcm-face-pied">${ico('arrows-clockwise', { taille: 16 })}Retourner la carte</span>
                </span>
                <span class="qcm-face qcm-face-verso"${retournee ? '' : html` aria-hidden="true"`}>
                    <span class="qcm-face-role">Réponse</span>
                    <span class="qcm-face-texte">${card.verso}</span>
                    ${card.explication ? html`<span class="qcm-face-note">${card.explication}</span>` : ''}
                    ${card.origine === 'qcm' ? html`<span class="qcm-face-cible">${ico('crosshair', { taille: 16 })}Cible une erreur de QCM</span>`
                        : card.origine === 'recall' ? html`<span class="qcm-face-cible">${ico('brain', { taille: 16 })}Cible une lacune d'active recall</span>` : ''}
                </span>
            </span>
        </button>
    </div>`;
}

// La ligne d'état au-dessus du carton : où on en est dans la file, et ce que la carte porte. partie : en
// révision réunie, la sous-partie d'où vient la carte.
export function enteteCarte(card, f, partie) {
    return html`<div class="qcm-carte-etat">
        <span class="num">Carte ${f.idx + 1} sur ${f.queue.length}</span>
        <span class="qcm-carte-etat-fin">
            ${partie ? html`<span class="puce puce-accent qcm-carte-partie">${partie}</span>` : ''}
            ${puceRang(card.rang)}
            ${card.notion ? html`<span class="qcm-carte-notion">${card.notion}</span>` : ''}
            ${card.section ? html`<span class="qcm-carte-section">${card.section}</span>` : ''}
            <span class="num qcm-carte-rythme">${card.reps ? 'vue ' + card.reps + '×  · intervalle ' + jours(card.ivl) : 'nouvelle carte'}</span>
        </span>
    </div>`;
}
